export default {
  dashboard: {
    name: 'dashboard',
  },
  cms: {
    name: 'CMS',
    settings: 'Settings',
    messages: 'Messages',
    menuItems: 'Menu items',
  },
  store: {
    name: 'Store',
    sections: 'Categories',
    products: 'Products',
    transactions: 'Transactions',
    customers: 'Customers',
    transactionProducts: 'Transactions - products',
  },
  blog: {
    name: 'Blog',
    categories: 'Categories',
    tags: 'Tags',
    posts: 'Posts',
    postTags: 'Posts - tags',
  },
  admin: {
    name: 'Administration',
    permissions: 'Permissions',
    users: 'Users',
    userPermissions: 'Users - permissions',
    userTypes: 'User types',
  },
}
